import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import bitsOfCode from "../../Assets/Projects/blog.png";
import gameDashBoard from "../../Assets/game-dashboard.png";

const PROJECTS_DATA = [
  {
    imgPath: chatify,
    title: "Redis Spring Boot",
    description: "A simple Redis Cache Implementation using Java Spring Boot to optimize response times and database load.",
    ghLink: "https://github.com/kiranaveen/Redis-Spring-Boot-Implementation",
    category: "Spring Boot & Java",
    tags: ["Java", "Spring Boot", "Redis", "Lombok", "Caching"],
    features: [
      "Designed custom caching mechanisms to speed up database reads.",
      "Implemented cache eviction policies and customized TTL (Time To Live) configurations.",
      "Integrated Lettuce and Jedis connection libraries.",
      "Achieved up to 70% decrease in response latency for heavy endpoints."
    ]
  },
  {
    imgPath: gameDashBoard,
    title: "Game Dashboard",
    description: "A dynamic and visually appealing web application to explore and filter a wide range of video games. Built using React, TypeScript, and Chakra UI. Leverages RAWG API to fetch live game data.",
    ghLink: "https://github.com/kiranaveen/game-hub-dashboard/tree/master",
    category: "Web Apps",
    tags: ["React.js", "TypeScript", "Chakra UI", "RAWG API", "Axios"],
    features: [
      "Integrated the RAWG Video Games Database API to pull extensive game details.",
      "Created fully responsive layout configurations with Chakra UI.",
      "Designed client-side search, genre filters, platform categorization, and sorting filters.",
      "Utilized custom React hooks to manage asynchronous fetching and error states cleanly."
    ]
  },
  {
    imgPath: bitsOfCode,
    title: "Spring Boot Mongo Atlas",
    description: "Performance testing repository for MongoDB Atlas integrations, leveraging multi-threading and CyclicBarrier to simulate load.",
    ghLink: "https://github.com/kiranaveen/MongoAtlasPerformanceRepo",
    category: "Databases & Performance",
    tags: ["Java", "Spring Boot", "MongoDB Atlas", "Concurrency", "CyclicBarrier"],
    features: [
      "Built a concurrent stress-test suite to analyze MongoDB Atlas query performance.",
      "Leveraged Java ExecutorService and CyclicBarrier to trigger simultaneous database connections.",
      "Collected metrics on connection latency and database performance thresholds.",
      "Optimized document indexes to prevent bottlenecks under highly concurrent request flows."
    ]
  },
  {
    imgPath: editor,
    title: "Spring Security",
    description: "Sleek and robust Spring Security implementation using Java Spring Boot. Demonstrates authentication, authorization, and JWT setups.",
    ghLink: "https://github.com/kiranaveen/Java-Spring-Security-",
    category: "Spring Boot & Java",
    tags: ["Java", "Spring Boot", "Spring Security", "JWT", "MySQL", "BCrypt"],
    features: [
      "Configured robust RESTful API security utilizing Spring Security Filters.",
      "Built secure JWT token creation, signing, parsing, and authorization filters.",
      "Configured Role-Based Access Control (RBAC) to secure endpoint routes.",
      "Stored user credentials securely utilizing BCrypt strong password hashing."
    ]
  },
  {
    imgPath: leaf,
    title: "Spring Validator",
    description: "Custom and standard validation mechanism implementations in Java Spring Boot applications to guarantee clean data input.",
    ghLink: "https://github.com/kiranaveen/SimpleSpringBootValidator",
    category: "Spring Boot & Java",
    tags: ["Java", "Spring Boot", "Hibernate Validator", "Validation API"],
    features: [
      "Configured Hibernate Validator annotations to validate request bodies.",
      "Designed customized annotations to handle complex business rules/constraints.",
      "Built a Global Exception Handler (`@ControllerAdvice`) to format friendly error lists.",
      "Prevented corrupted payload data structures from writing into persistent database layers."
    ]
  }
];

const CATEGORIES = ["All", "Spring Boot & Java", "Databases & Performance", "Web Apps"];

function Projects() {
  const [filter, setFilter] = useState("All");

  const filteredProjects = filter === "All"
    ? PROJECTS_DATA
    : PROJECTS_DATA.filter((project) => project.category === filter);

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white", paddingBottom: "15px" }}>
          Here are a few projects I've worked on recently. Click on any card to view detailed features.
        </p>

        {/* Filter Buttons */}
        <div className="filter-container">
          {CATEGORIES.map((category) => (
            <button
              key={category}
              className={`filter-btn ${filter === category ? "active" : ""}`}
              onClick={() => setFilter(category)}
            >
              {category}
            </button>
          ))}
        </div>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {filteredProjects.map((project, index) => (
            <Col md={4} className="project-card" key={index}>
              <ProjectCard
                imgPath={project.imgPath}
                isBlog={false}
                title={project.title}
                description={project.description}
                ghLink={project.ghLink}
                demoLink={project.demoLink}
                tags={project.tags}
                features={project.features}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
